import { useState } from 'react'
import { Observaciones } from '../../interfaces/facturacion.interface'
import EditIcon from '../../media/felsv/down-arrow-svgrepo-com.svg'

const MAX_CHARS = 1000
const MAX_REF = 25

interface ObservacionesDocumentoProps {
  formObservaciones: Observaciones
  onChange: (field: string, value: string | boolean) => void
}

const defaultObservaciones: Observaciones = {
  referencia: '',
  observaciones: '',
  mostrarObservacionesPdf: true,
  incluirObservacionesCorreo: true,
}

export default function ObservacionesDocumento({ formObservaciones, onChange }: ObservacionesDocumentoProps) {
  const [showContent, setShowContent] = useState(false)
  const form = formObservaciones ?? defaultObservaciones

  const charsLeft = MAX_CHARS - (form.observaciones?.length ?? 0)

  return (
    <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
      <div style={{ width: '100%', boxShadow: 'none' }} className='card'>
        <h3
          className='card-title l'
          onClick={() => setShowContent(!showContent)}
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
        >
          Información adicional
          <img src={EditIcon} style={{ marginLeft: '16px', width: '15px' }} alt='' />
        </h3>

        {showContent && (
          <>
            <div className='form-separator' />

            <div className='form-content'>
              {/* Referencia */}
              <div className='label-input'>
                <label className='field-label m'>Referencia</label>
                <input
                  type='text'
                  value={form.referencia}
                  onChange={(e) => onChange('referencia', e.target.value)}
                  placeholder='Ej: OC-001, PED-2024...'
                  maxLength={MAX_REF}
                  className='m text-field w-input'
                />
                <p style={{ fontSize: '11px', color: 'rgba(27, 27, 27, 0.4)', marginTop: '4px' }}>
                  Referencia interna para ubicar el documento en el histórico
                </p>
              </div>

              <div className='form-separator' />

              {/* Textarea */}
              <div className='label-input'>
                <label className='field-label m'>Observaciones</label>
                <textarea
                  value={form.observaciones}
                  onChange={(e) => onChange('observaciones', e.target.value)}
                  placeholder='Ingrese las observaciones del documento...'
                  maxLength={MAX_CHARS}
                  rows={4}
                  className='m text-field w-input'
                  style={{
                    height: 'auto',
                    minHeight: '100px',
                    resize: 'vertical',
                    paddingTop: '12px',
                    lineHeight: '1.5',
                  }}
                />
                <p
                  style={{
                    fontSize: '11px',
                    color: charsLeft <= 50 ? 'rgba(247, 29, 29, 0.978)' : 'rgba(27, 27, 27, 0.4)',
                    textAlign: 'right',
                    marginTop: '4px',
                  }}
                >
                  {charsLeft} caracteres restantes
                </p>
              </div>

              {/* Checkboxes — por defecto las observaciones se incluyen en todo */}
              <p style={{ fontSize: '12px', color: 'rgba(27, 27, 27, 0.5)', margin: '4px 0 8px' }}>
                Por defecto las observaciones se incluyen en el PDF y en el correo. Marque para excluirlas:
              </p>
              <div className='w-layout-hflex h-inputs'>
                <div className='label-input' style={{ flex: 'unset' }}>
                  <label className='container-checkbox m'>
                    No mostrar en PDF
                    <input
                      type='checkbox'
                      checked={!form.mostrarObservacionesPdf}
                      onChange={(e) => onChange('mostrarObservacionesPdf', !e.target.checked)}
                    />
                    <span className='checkmark-checkbox' />
                  </label>
                </div>

                <div className='label-input' style={{ flex: 'unset' }}>
                  <label className='container-checkbox m'>
                    No incluir en correo
                    <input
                      type='checkbox'
                      checked={!form.incluirObservacionesCorreo}
                      onChange={(e) => onChange('incluirObservacionesCorreo', !e.target.checked)}
                    />
                    <span className='checkmark-checkbox' />
                  </label>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
